var _defineProperty = require("@babel/runtime/helpers/defineProperty");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-await-in-loop */
const processState = async (state, evaluator) => {
  if (!state) {
    return null;
  }
  const result = await evaluator(state.test);
  return result;
};

/**
  * @function evalute - evaluate stateMachineBehavior
  */
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, evaluator) => {
  const unevaluatedStateIdentifier = source.stateIdentifier,
    _source$states = source.states,
    originalStates = _source$states === void 0 ? [] : _source$states,
    unevaluatedInitialState = source.initialState,
    unevaluatedAuto = source.auto;
  const stateIdentifier = await evaluator(unevaluatedStateIdentifier);
  const auto = await evaluator(unevaluatedAuto);
  const initialState = await evaluator(unevaluatedInitialState);
  if (!stateIdentifier && initialState) {
    return initialState;
  }
  const states = JSON.parse(JSON.stringify(originalStates));
  const currentStates = [];
  for (let i = 0; i < states.length; i += 1) {
    const state = states[i];
    const identifier = await evaluator(state.identifier);
    if (identifier === stateIdentifier) {
      currentStates.push(state);
    }
  }
  if (currentStates.length === 0) {
    // State identifier is not present in state machine
    return stateIdentifier;
  }
  let nextIdentifier;
  for (let i = 0; i < currentStates.length; i += 1) {
    const currentState = currentStates[i];
    const _currentState$nextSta = currentState.nextState,
      _currentState$nextSta2 = _currentState$nextSta === void 0 ? {} : _currentState$nextSta,
      unevaluatedNextStateIdentifier = _currentState$nextSta2.identifier;
    const result = await processState(currentState.nextState, evaluator);
    if (result) {
      const nextStateIdentifier = await evaluator(unevaluatedNextStateIdentifier);
      nextIdentifier = nextStateIdentifier;
      break;
    }
  }
  if (!nextIdentifier) {
    return stateIdentifier;
  }
  // Should check to see if the next identifier is skippable
  if (auto) {
    return evaluator(_objectSpread(_objectSpread({}, source), {}, {
      stateIdentifier: nextIdentifier
    }));
  }
  return nextIdentifier;
};
module.exports = {
  evaluate
};